// Angular
import { Component, AfterContentInit, OnChanges } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { Output, EventEmitter, SimpleChange } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';

// Rx
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';

// Services
import { AuthService } from 'app/_services';
import { EntryService } from 'app/_services';

// Models
import { Theme } from 'app/_models';

// Environment
import { environment } from 'environments/environment';

// 3rd party
import { NgForage, Driver, NgForageCache, NgForageConfig, CachedItem } from 'ngforage';

@Component({
    selector: 'navmenu',
    templateUrl: 'navmenu.component.html',
    styleUrls: ['./navmenu.component.scss'],
    providers: [
        EntryService,
        NgForage,
        NgForageCache
    ]
})

export class NavMenuComponent implements OnInit, OnDestroy, AfterContentInit, OnChanges {
    @Output() change: EventEmitter<any> = new EventEmitter<any>();

    private bearerToken = '';
    private authenticationProvider = '';

    public menuItems: any;

    public themeData: Theme = new Theme();

    constructor(
        private router: Router,
        private httpClient: HttpClient,
        private entryService: EntryService,
        private ngf: NgForage,
    ) {
        const authService: AuthService = new AuthService();

        this.authenticationProvider = authService.getAuthenticationProvider();
        this.bearerToken = authService.getToken();
    }

    public navigateTo(GoTo: any = '/dashboard', target: string = null): void {
        if (GoTo.url.indexOf('https') === 0) {
            setTimeout(() => {
                if (GoTo.login) {
                    GoTo.url = GoTo.url + '#/dashboard?authenticationProvider=' + this.authenticationProvider;
                }

                window.location.href = GoTo.url;
            }, 200);
        } else {
            this.router.navigate([GoTo]);
        }
    }

    private initMenu(menu: any): void {
        this.menuItems = menu;
    }

    private loadMenu(): Promise<any> {
        const sUrl: string = environment.NavMenuUrl;

        return this.httpClient
            //.get(`${sUrl}?t=${new Date().getTime()}`)
            .get(`${sUrl}`)
            .toPromise()
            .then(response => {
                return response || {};
            });
    }

    ngAfterContentInit() {
        console.log('NavMenuComponent: ngAfterContentInit');
    }

    ngOnInit() {
        console.log('NavMenuComponent: ngOnInit');

        const navMenuUrl: string = environment.NavMenuUrl;

        if (navMenuUrl) {
            this.loadMenu().then(result => {
                this.initMenu(result);
            });
        }

        this.entryService.getAction().subscribe(data => {
            if (data['action']) {
                const action = data['action'];

                if (action === 'ThemeChange') {
                    this.themeData = data['value'];
                }
            }
        });

        this.ngf.getItem<Theme>('theme')
            .then(data => {
                if (data) {
                    this.themeData = data;
                } else {
                    this.ngf.setItem('theme', this.themeData);
                }
            });
    }

    ngOnDestroy() {
        console.log('NavMenuComponent: ngOnDestroy');
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        console.log('NavMenuComponent: ngOnChanges');
    }
}
